module.exports = __webpack_public_path__ + "static/media/advertisers_section3.8ebce888.png";